import { Capacitor } from '@capacitor/core';
import { toast } from 'react-toastify';

export const usePromoCode = () => {
  const handlePromoCode = async () => {
    const platform = Capacitor.getPlatform();
    if (platform === 'android') {
      try {
        window.open('https://play.google.com/redeem', '_system');
      } catch (error) {
        console.error('Error opening Play Store:', error);
      }
    } else {
      toast('Promo codes are only available on mobile devices');
    }
  };

  return { handlePromoCode };
};
